module.exports = __webpack_public_path__ + "static/media/tree_4.1004f235.svg";